import { ProductContext } from "~/providers/ProductProvider";
import { useContext } from "react";

export const useProductContext = () => {
  const productContext = useContext<ProductContext>(ProductContext);
  return { ...productContext };
};
